/* eslint-disable max-lines */
import { ICountLandingZone } from '../../../components/layout/HomePage/HomePageConstants';
import {
  IAllEnvironmentsRespObj,
  ICreateEnvironmentPayload,
  IDownloadArchitectureDiagramPayload,
  IFetchCategoryAndTechDomainResponse,
  IGetEnvironmentsQueryParams,
  IGetWorkloadQueryParams,
  IUploadArchitecturePayload,
  IWorkloadPatternRespObj,
} from '../../models/BuildDeployModels';
import {
  ICheckLandingZoneStatus,
  ICheckMicroServicesPatternStatus,
  IConfigureMicroServiceError,
  IConfigureWorkLoadsPattern,
} from '../../models/DashboardModels';
import {
  IArchitectureCataloguePayload,
  IArchitectureCatalogueResponse,
  ICloudLandingZoneKeysPayload,
  ICloudLandingZoneKeysResponse,
  IConfigureDeployCloudPayload,
  IConfigureDeployCloudThroughConsolePayload,
  IConfigureLandingZonePayload,
  IConfigureLandingZoneRequestPayload,
  IConfigureLZLoadingPayload,
  ICreateYamlPayload,
  IDeleteLandingZonePayload,
  IDeleteWorkLoadPatternPayload,
  IDeploymentLogsPayload,
  IDeploymentLogsResponse,
  IDeploymentsResponse,
  IEnvironmentsDeployed,
  ILandingZoneDeploymentStatus,
  ILandingZoneState,
  IPipelinesAnalyticsResponse,
  IPipelinesCummulativeAnalyticsResponse,
  IYamlContent,
  IDeployValueState,
  ILandingZoneDeploymentResponse,
  IUpdateDeployActivityHistoryPayload,
  IDeployActivityHistory,
  IUpdateLandingZoneDeployDetails,
  IFormInterface,
  IIndustryYamlPayload,
  IGetKeysRequestBody,
  IUploadPayload,
  IIndustryPolicy,
  IIndustryCompliance,
  IIndustryPolicyRequest,
  IGenAiCreatePayload,
  IGenAiCreateResponse,
  IGenAiCreateDownloadPayload,
  IValidateYamlPayload,
  IWorkFLowLogsResponse,
  IValidateLandingZonePayload,
  IUploadCustomArchitectureFilePayload,
  IUploadCustomArchitectureFileResponse,
  IUploadCustomCloudConfigurationFilePayload,
  IUploadCustomCloudConfigurationFileResponse,
  ICloudBuildConfigVariable,
  ICloudBuildTfVarsPayload,
  IValidateCustomConfigurationPayload,
  IGenerateArchitectureDiagramsPayload,
  IGenerateArchitectureDiagramsResponse,
  IReviseArchitectureDiagramsPayload,
  IUploadArchitectureDiagramsPayload,
  IUploadArchitectureDiagramsResponse,
  IUploadArchitectureDiagramsPayloadWithFile,
  IGeneratedArchitectureDiagramHistoryStackItem,
  DiagramType,
  IConvertArchitectureDiagramsPayload,
  IConvertArchitectureDiagramsResponse,
  IConvertArchitectureDiagramsResponseWithType,
} from '../state/BuildDeployState';
import { IStoreAction } from '../StoreHelper';

export enum BuildDeployActionTypes {
  ADD_LANDING_ZONE = 'ADD_LANDING_ZONE',
  GET_BUILD_DEPLOY_DETAILS_STARTED = 'GET_BUILD_DEPLOY_DETAILS_STARTED',
  GET_BUILD_DEPLOY_DETAILS_SUCCESS = 'GET_BUILD_DEPLOY_DETAILS_SUCCESS',
  GET_BUILD_DEPLOY_DETAILS_ERROR = 'GET_BUILD_DEPLOY_DETAILS_ERROR',
  ENABLE_LANDING_ZONE_STARTED = 'ENABLE_LANDING_ZONE_STARTED',
  ENABLE_LANDING_ZONE_SUCCESS = 'ENABLE_LANDING_ZONE_SUCCESS',
  ENABLE_LANDING_ZONE_ERROR = 'ENABLE_LANDING_ZONE_ERROR',
  DISABLE_LANDING_ZONE = 'DISABLE_LANDING_ZONE',

  CONFIGURE_CUSTOM_LANDING_ZONE_STARTED = 'CONFIGURE_CUSTOM_LANDING_ZONE_STARTED',
  CONFIGURE_CUSTOM_LANDING_ZONE_ERROR = 'CONFIGURE_CUSTOM_LANDING_ZONE_ERROR',

  CONFIGURE_LANDING_ZONE_STARTED = 'CONFIGURE_LANDING_ZONE_STARTED',
  CONFIGURE_LANDING_ZONE_SUCCESS = 'CONFIGURE_LANDING_ZONE_SUCCESS',
  CONFIGURE_LANDING_ZONE_LOADING = 'CONFIGURE_LANDING_ZONE_LOADING',
  CHECK_LANDING_ZONE_STATUS = 'CHECK_LANDING_ZONE_STATUS',
  CONFIGURE_LANDING_ZONE_ERROR = 'CONFIGURE_LANDING_ZONE_ERROR',
  DELETE_LANDING_ZONE_STARTED = 'DELETE_LANDING_ZONE',
  DELETE_LANDING_ZONE_SUCCESS = 'DELETE_LANDING_ZONE_SUCCESS',
  DELETE_LANDING_ZONE_ERROR = 'DELETE_LANDING_ZONE_ERROR',
  ENABLE_MICROSERVIVES_PATTERN_STARTED = 'ENABLE_MICROSERVIVES_PATTERN_STARTED',
  ENABLE_MICROSERVIVES_PATTERN_SUCCESS = 'ENABLE_MICROSERVIVES_PATTERN_SUCCESS',
  ENABLE_MICROSERVIVES_PATTERN_ERROR = 'ENABLE_MICROSERVIVES_PATTERN_ERROR',
  CONFIGURE_MICROSERVIVES_PATTERN_STARTED = 'CONFIGURE_MICROSERVIVES_PATTERN_STARTED',
  CONFIGURE_MICROSERVIVES_PATTERN_ERROR = 'CONFIGURE_MICROSERVIVES_PATTERN_ERROR',
  CONFIGURE_MICROSERVIVES_PATTERN_LOADING = 'CONFIGURE_MICROSERVIVES_PATTERN_LOADING',
  CHECK_MICROSERVIVES_PATTERN_STATUS = 'CHECK_MICROSERVIVES_PATTERN_STATUS',
  CONFIGURE_MICROSERVIVES_PATTERN_SUCCESS = 'CONFIGURE_MICROSERVIVES_PATTERN_SUCCESS',
  CONFIGURE_MICROSERVIVES_PATTERN_FAILED = 'CONFIGURE_MICROSERVIVES_PATTERN_FAILED',
  ENABLE_ETL_PATTERN_STARTED = 'ENABLE_ETL_PATTERN_STARTED',
  ENABLE_ETL_PATTERN_SUCCESS = 'ENABLE_ETL_PATTERN_SUCCESS',
  ENABLE_ETL_PATTERN_ERROR = 'ENABLE_ETL_PATTERN_ERROR',
  CONFIGURE_ETL_PATTERN_STARTED = 'CONFIGURE_ETL_PATTERN_STARTED',
  CONFIGURE_ETL_PATTERN_SUCCESS = 'CONFIGURE_ETL_PATTERN_SUCCESS',
  CONFIGURE_ETL_PATTERN_ERROR = 'CONFIGURE_ETL_PATTERN_ERROR',

  DESTROY_WORKLOAD_PATTERN_SUCCESS = 'DESTROY_WORKLOAD_PATTERN_SUCCESS',
  DESTROY_WORKLOAD_PATTERN_STARTED = 'DESTROY_WORKLOAD_PATTERN_STARTED',
  DESTROY_WORKLOAD_PATTERN_ERROR = 'DESTROY_WORKLOAD_PATTERN_ERROR',

  GET_ALL_AVAILABLE_WORKLOAD_PATTERN_SUCCESS = 'GET_ALL_AVAILABLE_WORKLOAD_PATTERN_SUCCESS',
  GET_ALL_AVAILABLE_WORKLOAD_PATTERN_STARTED = 'GET_ALL_AVAILABLE_WORKLOAD_PATTERN_STARTED',
  GET_ALL_AVAILABLE_WORKLOAD_PATTERN_ERROR = 'GET_ALL_AVAILABLE_WORKLOAD_PATTERN_ERROR',

  GET_ALL_ENVIRONMENTS_SUCCESS = 'GET_ALL_ENVIRONMENTS_SUCCESS',
  GET_ALL_ENVIRONMENTS_STARTED = 'GET_ALL_ENVIRONMENTS_STARTED',
  GET_ALL_ENVIRONMENTS_ERROR = 'GET_ALL_ENVIRONMENTS_ERROR',
  CREATE_ENVIRONMENT_SUCCESS = 'CREATE_ENVIRONMENT_SUCCESS',
  CREATE_ENVIRONMENT_STARTED = 'CREATE_ENVIRONMENT_STARTED',
  CREATE_ENVIRONMENT_ERROR = 'CREATE_ENVIRONMENT_ERROR',

  GET_LANDING_ZONE_ERRORS_STARTED = 'GET_LANDING_ZONE_ERRORS_STARTED',
  GET_LANDING_ZONE_ERRORS_SUCCESS = 'GET_LANDING_ZONE_ERRORS_SUCCESS',
  GET_LANDING_ZONE_ERRORS_FAILED = 'GET_LANDING_ZONE_ERRORS_FAILED',
  CONFIGURE_LANDING_ERROR_SUCCESS = 'CONFIGURE_LANDING_ERROR_SUCCESS',
  SET_TOTAL_ENVIRONMENTS = 'SET_TOTAL_ENVIRONMENTS',
  SET_CATALOGUE_TYPE = 'SET_CATALOGUE_TYPE',
  CREATE_LANDING_ZONE_YAML_START = 'CREATE_LANDING_ZONE_YAML_START',
  CREATE_LANDING_ZONE_YAML_SUCCESS = 'CREATE_LANDING_ZONE_YAML_SUCCESS',
  CREATE_LANDING_ZONE_YAML_ERROR = 'CREATE_LANDING_ZONE_YAML_ERROR',
  ENVIRONMENTS_DEPLOYED_START = 'ENVIRONMENTS_DEPLOYED_START',
  ENVIRONMENTS_DEPLOYED_SUCCESS = 'ENVIRONMENTS_DEPLOYED_SUCCESS',
  ENVIRONMENTS_DEPLOYED_ERROR = 'ENVIRONMENTS_DEPLOYED_ERROR',
  SET_SELECTED_TAB = ' SET_SELECTED_TAB',
  LANDING_ZONES_DEPLOYMENT_STATUS_START = 'LANDING_ZONES_DEPLOYMENT_STATUS_START',
  LANDING_ZONES_DEPLOYMENT_STATUS_SUCCESS = 'LANDING_ZONES_DEPLOYMENT_STATUS_SUCCESS',
  LANDING_ZONES_DEPLOYMENT_STATUS_ERROR = 'LANDING_ZONES_DEPLOYMENT_STATUS_ERROR',
  GET_ARCHITECTURE_LIST_STARTED = 'GET_ARCHITECTURE_LIST_STARTED',
  GET_ARCHITECTURE_LIST_SUCCESS = 'GET_ARCHITECTURE_LIST_SUCCESS',
  GET_ARCHITECTURE_LIST_ERROR = 'GET_ARCHITECTURE_LIST_ERROR',
  SET_ARCHTECTURE_VIEW_COUNT_STARTED = 'SET_ARCHTECTURE_VIEW_COUNT_STARTED',
  SET_ARCHTECTURE_VIEW_COUNT_SUCCESS = 'SET_ARCHTECTURE_VIEW_COUNT_SUCCESS',
  SET_ARCHTECTURE_VIEW_COUNT_ERROR = 'SET_ARCHTECTURE_VIEW_COUNT_ERROR',
  SET_ARCHTECTURE_DIAGRAM_STARTED = 'SET_ARCHTECTURE_DIAGRAM_STARTED',
  SET_ARCHTECTURE_DIAGRAM_SUCCESS = 'SET_ARCHTECTURE_DIAGRAM_SUCCESS',
  SET_ARCHTECTURE_DIAGRAM_ERROR = 'SET_ARCHTECTURE_DIAGRAM_ERROR',
  GET_PIPELINES_ANALYTICS_STARTED = 'GET_PIPELINES_ANALYTICS_STARTED',
  GET_PIPELINES_ANALYTICS_SUCCESS = 'GET_PIPELINES_ANALYTICS_SUCCESS',
  GET_PIPELINES_ANALYTICS_ERROR = 'GET_PIPELINES_ANALYTICS_ERROR',
  GET_PIPELINES_CUMMULATIVE_ANALYTICS_STARTED = 'GET_PIPELINES_CUMMULATIVE_ANALYTICS_STARTED',
  GET_PIPELINES_CUMMULATIVE_ANALYTICS_SUCCESS = 'GET_PIPELINES_CUMMULATIVE_ANALYTICS_SUCCESS',
  GET_PIPELINES_CUMMULATIVE_ANALYTICS_ERROR = 'GET_PIPELINES_CUMMULATIVE_ANALYTICS_ERROR',
  GET_YAML_CONTENT_STARTED = 'GET_YAML_CONTENT_STARTED',
  GET_YAML_CONTENT_SUCCESS = 'GET_YAML_CONTENT_SUCCESS',
  GET_YAML_CONTENT_ERROR = 'GET_YAML_CONTENT_ERROR',
  GET_INDUSTRY_YAML_CONTENT_STARTED = 'GET_INDUSTRY_YAML_CONTENT_STARTED',
  GET_INDUSTRY_YAML_CONTENT_SUCCESS = 'GET_INDUSTRY_YAML_CONTENT_SUCCESS',
  GET_INDUSTRY_YAML_CONTENT_ERROR = 'GET_INDUSTRY_YAML_CONTENT_ERROR',
  GET_CLOUD_LANDING_ZONE_KEYS_STARTED = 'GET_CLOUD_LANDING_ZONE_KEYS_STARTED',
  GET_CLOUD_LANDING_ZONE_KEYS_SUCCESS = 'GET_CLOUD_LANDING_ZONE_KEYS_SUCCESS',
  GET_CLOUD_LANDING_ZONE_KEYS_ERROR = 'GET_CLOUD_LANDING_ZONE_KEYS_ERROR',
  SET_CLOUD_LANDING_ZONE_KEYS_STARTED = 'SET_CLOUD_LANDING_ZONE_KEYS_STARTED',
  SET_CLOUD_LANDING_ZONE_KEYS_SUCCESS = 'SET_CLOUD_LANDING_ZONE_KEYS_SUCCESS',
  SET_CLOUD_LANDING_ZONE_KEYS_ERROR = 'SET_CLOUD_LANDING_ZONE_KEYS_ERROR',
  GET_DEPLOYMENT_DETAILS_STARTED = 'GET_DEPLOYMENT_DETAILS_STARTED',
  GET_DEPLOYMENT_DETAILS_SUCCESS = 'GET_DEPLOYMENT_DETAILS_SUCCESS',
  GET_DEPLOYMENT_DETAILS_ERROR = 'GET_DEPLOYMENT_DETAILS_ERROR',
  CONFIGURE_DEPLOY_CLOUD_STARTED = 'CONFIGURE_DEPLOY_CLOUD_STARTED',
  CONFIGURE_DEPLOY_CLOUD_SUCCESS = 'CONFIGURE_DEPLOY_CLOUD_SUCCESS',
  CONFIGURE_DEPLOY_CLOUD_ERROR = 'CONFIGURE_DEPLOY_CLOUD_ERROR',
  CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_STARTED = 'CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_STARTED',
  CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_SUCCESS = 'CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_SUCCESS',
  CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_ERROR = 'CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_ERROR',
  CLOUD_LANDING_ZONE_DEPLOY_STATUS_STARTED = 'CLOUD_LANDING_ZONE_DEPLOY_STATUS_STARTED',
  CLOUD_LANDING_ZONE_DEPLOY_STATUS_SUCCESS = 'CLOUD_LANDING_ZONE_DEPLOY_STATUS_SUCCESS',
  CLOUD_LANDING_ZONE_DEPLOY_STATUS_ERROR = 'CLOUD_LANDING_ZONE_DEPLOY_STATUS_ERROR',
  GET_DEPLOYMENT_AUDIT_STARTED = 'GET_DEPLOYMENT_AUDIT_STARTED',
  GET_DEPLOYMENT_AUDIT_SUCCESS = 'GET_DEPLOYMENT_AUDIT_SUCCESS',
  GET_DEPLOYMENT_AUDIT_ERROR = 'GET_DEPLOYMENT_AUDIT_ERROR',
  GET_DEPLOY_INPUTS = 'GET_DEPLOY_INPUTS',
  CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_STARTED = 'CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_STARTED',
  CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_SUCCESS = 'CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_SUCCESS',
  CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_ERROR = 'CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_ERROR',
  GET_MULTICLOUD_YAML_CONTENT_STARTED = 'GET_MULTICLOUD_YAML_CONTENT_STARTED',
  GET_MULTICLOUD_YAML_CONTENT_SUCCESS = 'GET_MULTICLOUD_YAML_CONTENT_SUCCESS',
  GET_MULTICLOUD_YAML_CONTENT_ERROR = 'GET_MULTICLOUD_YAML_CONTENT_ERROR',
  GET_DEFAULT_TEMPLATE_YAML_CONTENT_STARTED = 'GET_DEFAULT_TEMPLATE_YAML_CONTENT_STARTED',
  GET_DEFAULT_TEMPLATE_YAML_CONTENT_FOR_CLOUD_STARTED = 'GET_DEFAULT_TEMPLATE_YAML_CONTENT_FOR_CLOUD_STARTED',
  GET_DEFAULT_TEMPLATE_YAML_CONTENT_SUCCESS = 'GET_DEFAULT_TEMPLATE_YAML_CONTENT_SUCCESS',
  GET_DEFAULT_TEMPLATE_YAML_CONTENT_ERROR = 'GET_DEFAULT_TEMPLATE_YAML_CONTENT_ERROR',
  GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_STARTED = 'GET_DEFAULT_TEMPLATE_ARCH_DIAGRAM_CONTENT_STARTED',
  GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_SUCCESS = 'GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_SUCCESS',
  GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_ERROR = 'GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_ERROR',
  DEPLOY_LANDING_ZONE_STARTED = 'DEPLOY_LANDING_ZONE_STARTED',
  DEPLOY_LANDING_ZONE_SUCCESS = 'DEPLOY_LANDING_ZONE_SUCCESS',
  DEPLOY_LANDING_ZONE_LOADING = 'DEPLOY_LANDING_ZONE_LOADING',
  DEPLOY_LANDING_ZONE_ERROR = 'DEPLOY_LANDING_ZONE_ERROR',
  VALIDATE_YAML_STARTED = 'VALIDATE_YAML_STARTED',
  VALIDATE_YAML_FOR_CLOUD_STARTED = 'VALIDATE_YAML_FOR_CLOUD_STARTED',
  VALIDATE_YAML_SUCCESS = 'VALIDATE_YAML_SUCCESS',
  VALIDATE_YAML_ERROR = 'VALIDATE_YAML_ERROR',
  VALIDATE_YAML_CLEAR = 'VALIDATE_YAML_CLEAR',

  VALIDATE_LANDING_ZONE_STARTED = 'VALIDATE_LANDING_ZONE_STARTED',
  VALIDATE_LANDING_ZONE_SUCCESS = 'VALIDATE_LANDING_ZONE_SUCCESS',
  VALIDATE_LANDING_ZONE_ERROR = 'VALIDATE_LANDING_ZONE_ERROR',

  FETCH_INDUSTRY_POLICIES_STARTED = 'FETCH_INDUSTRY_POLICIES_STARTED',
  FETCH_INDUSTRY_POLICIES_FOR_CLOUD_STARTED = 'FETCH_INDUSTRY_POLICIES_FOR_CLOUD_STARTED',
  FETCH_INDUSTRY_POLICIES_SUCCESS = 'FETCH_INDUSTRY_POLICIES_SUCCESS',
  FETCH_INDUSTRY_POLICIES_ERROR = 'FETCH_INDUSTRY_POLICIES_ERROR',

  FETCH_INDUSTRY_COMPLIANCES_STARTED = 'FETCH_INDUSTRY_COMPLIANCES_STARTED',
  FETCH_INDUSTRY_COMPLIANCES_SUCCESS = 'FETCH_INDUSTRY_COMPLIANCES_SUCCESS',
  FETCH_INDUSTRY_COMPLIANCES_ERROR = 'FETCH_INDUSTRY_COMPLIANCES_ERROR',

  DOWNLOAD_ARCHITECTURE_DIAGRAM_START = 'DOWNLOAD_ARCHITECTURE_DIAGRAM_START',
  DOWNLOAD_ARCHITECTURE_DIAGRAM_SUCCESS = 'DOWNLOAD_ARCHITECTURE_DIAGRAM_SUCCESS',
  DOWNLOAD_ARCHITECTURE_DIAGRAM_ERROR = 'DOWNLOAD_ARCHITECTURE_DIAGRAM_ERROR',
  DOWNLOAD_ARCHITECTURE_DIAGRAM_CLEAR = 'DOWNLOAD_ARCHITECTURE_DIAGRAM_CLEAR',

  FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_START = 'FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_START',
  FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_SUCCESS = 'FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_SUCCESS',
  FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_ERROR = 'FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_ERROR',

  UPLOAD_ARCHITECTURE_START = 'UPLOAD_ARCHITECTURE_START',
  UPLOAD_ARCHITECTURE_SUCCESS = 'UPLOAD_ARCHITECTURE_SUCCESS',
  UPLOAD_ARCHITECTURE_ERROR = 'UPLOAD_ARCHITECTURE_ERROR',

  FETCH_INDUSTRY_POLICY_YAML_START = 'FETCH_INDUSTRY_POLICY_YAML_START',
  FETCH_INDUSTRY_POLICY_YAML_SUCCESS = 'FETCH_INDUSTRY_POLICY_YAML_SUCCESS',
  FETCH_INDUSTRY_POLICY_YAML_ERROR = 'FETCH_INDUSTRY_POLICY_YAML_ERROR',

  FETCH_TERRAFORM_CODE_START = 'FETCH_TERRAFORM_CODE_START',
  FETCH_TERRAFORM_CODE_FOR_CLOUD_START = 'FETCH_TERRAFORM_CODE_FOR_CLOUD_START',
  FETCH_TERRAFORM_CODE_SUCCESS = 'FETCH_TERRAFORM_CODE_SUCCESS',
  FETCH_TERRAFORM_CODE_ERROR = 'FETCH_TERRAFORM_CODE_ERROR',

  GET_GEN_AI_CREATE_SERVICES_STARTED = 'GET_GEN_AI_CREATE_SERVICES_STARTED',
  GET_GEN_AI_CREATE_SERVICES_SUCCESS = 'GET_GEN_AI_CREATE_SERVICES_SUCCESS',
  GET_GEN_AI_CREATE_SERVICES_ERROR = 'GET_GEN_AI_CREATE_SERVICES_ERROR',

  GET_GEN_AI_CREATE_YAML_CONTENT_STARTED = 'GET_GEN_AI_CREATE_YAML_CONTENT_STARTED',
  GET_GEN_AI_CREATE_YAML_CONTENT_SUCCESS = 'GET_GEN_AI_CREATE_YAML_CONTENT_SUCCESS',
  GET_GEN_AI_CREATE_YAML_CONTENT_ERROR = 'GET_GEN_AI_CREATE_YAML_CONTENT_ERROR',

  GET_GEN_AI_CREATE_POLLING_SUCCESS = 'GET_GEN_AI_CREATE_POLLING_SUCCESS',
  GET_GEN_AI_CREATE_POLLING_ERROR = 'GET_GEN_AI_CREATE_POLLING_ERROR',

  GET_GEN_AI_CREATE_DOWNLOAD_STARTED = 'GET_GEN_AI_CREATE_DOWNLOAD_STARTED',
  GET_GEN_AI_CREATE_DOWNLOAD_SUCCESS = 'GET_GEN_AI_CREATE_DOWNLOAD_SUCCESS',
  GET_GEN_AI_CREATE_DOWNLOAD_ERROR = 'GET_GEN_AI_CREATE_DOWNLOAD_ERROR',

  BUILD_DEPLOY_HARD_RELOAD = 'BUILD_DEPLOY_HARD_RELOAD',

  GET_WORKFLOW_LOGS_STARTED = 'GET_WORKFLOW_LOGS_STARTED',
  GET_WORKFLOW_LOGS_SUCCESS = 'GET_WORKFLOW_LOGS_SUCCESS',
  GET_WORKFLOW_LOGS_ERROR = 'GET_WORKFLOW_LOGS_ERROR',

  VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_STARTED = 'VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_STARTED',
  VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_SUCCESS = 'VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_SUCCESS',
  VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_ERROR = 'VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_ERROR',

  UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_STARTED = 'UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_STARTED',
  UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_SUCCESS = 'UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_SUCCESS',
  UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_ERROR = 'UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_ERROR',

  GET_CLOUD_BUILD_CONFIG_VARIABLES_STARTED = 'GET_CLOUD_BUILD_CONFIG_VARIABLES_STARTED',
  GET_CLOUD_BUILD_CONFIG_VARIABLES_SUCCESS = 'GET_CLOUD_BUILD_CONFIG_VARIABLES_SUCCESS',
  GET_CLOUD_BUILD_CONFIG_VARIABLES_ERROR = 'GET_CLOUD_BUILD_CONFIG_VARIABLES_ERROR',

  GENERATE_ARCHITECTURE_DIAGRAMS_STARTED = 'GENERATE_ARCHITECTURE_DIAGRAMS_STARTED',
  GENERATE_ARCHITECTURE_DIAGRAMS_SUCCESS = 'GENERATE_ARCHITECTURE_DIAGRAMS_SUCCESS',
  GENERATE_ARCHITECTURE_DIAGRAMS_ERROR = 'GENERATE_ARCHITECTURE_DIAGRAMS_ERROR',

  REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_STARTED = 'REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_STARTED',
  REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_SUCCESS = 'REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_SUCCESS',
  REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_ERROR = 'REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_ERROR',

  UNDO_DIAGRAM = 'UNDO_DIAGRAM',
  REDO_DIAGRAM = 'REDO_DIAGRAM',

  CLEAR_DIAGRAM_HISTORY_AND_CURRENT = 'CLEAR_DIAGRAM_HISTORY_AND_CURRENT',

  UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_STARTED = 'UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_STARTED',
  UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_SUCCESS = 'UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_SUCCESS',
  UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_ERROR = 'UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_ERROR',

  CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_STARTED = 'CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_STARTED',
  CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_SUCCESS = 'CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_SUCCESS',
  CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_ERROR = 'CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_ERROR',
}

export interface IConfigureLandingZoneError {
  error: Error;
  index: number;
}
export interface ILandingZoneErrorResponse {
  [error: string]: string[];
}

export type BuildDeployActionPayload =
  | boolean
  | Error
  | ILandingZoneState
  | IConfigureLandingZoneRequestPayload
  | IConfigureLandingZonePayload
  | number
  | string
  | ILandingZoneState[]
  | IConfigureLandingZoneError
  | IDeleteLandingZonePayload
  | IConfigureWorkLoadsPattern
  | ICheckLandingZoneStatus
  | IConfigureLZLoadingPayload
  | IDeleteWorkLoadPatternPayload
  | ILandingZoneErrorResponse
  | IConfigureMicroServiceError
  | ICheckMicroServicesPatternStatus
  | ICreateYamlPayload
  | IEnvironmentsDeployed[]
  | ILandingZoneDeploymentStatus[]
  | ICountLandingZone
  | ICountLandingZone
  | IArchitectureCatalogueResponse[]
  | IPipelinesAnalyticsResponse[]
  | IPipelinesCummulativeAnalyticsResponse[]
  | IArchitectureCataloguePayload
  | IYamlContent
  | ICloudLandingZoneKeysResponse[]
  | ICloudLandingZoneKeysPayload
  | IDeploymentsResponse[]
  | IConfigureDeployCloudPayload
  | IConfigureDeployCloudThroughConsolePayload
  | IDeploymentLogsPayload
  | IDeploymentLogsResponse[]
  | IDeployValueState
  | ILandingZoneDeploymentResponse
  | IUpdateDeployActivityHistoryPayload
  | IFormInterface
  | IGetKeysRequestBody
  | IGetWorkloadQueryParams
  | Array<IWorkloadPatternRespObj>
  | Array<IAllEnvironmentsRespObj>
  | IUploadPayload
  | IValidateYamlPayload
  | IValidateLandingZonePayload
  | IIndustryYamlPayload
  | IGetEnvironmentsQueryParams
  | ICreateEnvironmentPayload
  | Array<IIndustryPolicy>
  | Array<IIndustryCompliance>
  | IDownloadArchitectureDiagramPayload
  | IFetchCategoryAndTechDomainResponse
  | IUploadArchitecturePayload
  | IIndustryPolicyRequest
  | Array<string>
  | IGenAiCreatePayload
  | IGenAiCreateResponse
  | IGenAiCreateDownloadPayload
  | IWorkFLowLogsResponse
  | IUploadCustomArchitectureFilePayload
  | IUploadCustomArchitectureFileResponse
  | IUploadCustomCloudConfigurationFileResponse
  | Array<ICloudBuildConfigVariable>
  | ICloudBuildTfVarsPayload
  | Record<string, Array<string>>
  | IGenerateArchitectureDiagramsPayload
  | IGenerateArchitectureDiagramsResponse
  | IGeneratedArchitectureDiagramHistoryStackItem
  | IReviseArchitectureDiagramsPayload
  | IReviseArchitectureDiagramsPayload
  | IUploadArchitectureDiagramsPayload
  | IUploadArchitectureDiagramsPayloadWithFile
  | IUploadArchitectureDiagramsResponse
  | IConvertArchitectureDiagramsPayload
  | IConvertArchitectureDiagramsResponse
  | IConvertArchitectureDiagramsResponseWithType;

export type BuildDeployAction = IStoreAction<BuildDeployActionTypes, BuildDeployActionPayload>;
export class BuildDeployActions {
  public static addLandingZone(data: ILandingZoneState): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ADD_LANDING_ZONE,
      data,
    };
  }
  public static getBuildDeployDetailStarted(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_BUILD_DEPLOY_DETAILS_STARTED,
      data,
    };
  }
  public static getBuildDeployDetailsSuccess(data: ILandingZoneState[]): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_BUILD_DEPLOY_DETAILS_SUCCESS,
      data,
    };
  }
  public static getBuildDeployDetailsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_BUILD_DEPLOY_DETAILS_ERROR,
      data,
    };
  }
  public static enableLandingZoneStarted(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_LANDING_ZONE_STARTED,
      data,
    };
  }

  public static disableLandingZone(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DISABLE_LANDING_ZONE,
      data,
    };
  }

  public static enableLandingZoneSuccess(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_LANDING_ZONE_SUCCESS,
      data,
    };
  }
  public static enableLandingZoneError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_LANDING_ZONE_ERROR,
      data,
    };
  }
  public static enableMicroServicesPatternStarted(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_MICROSERVIVES_PATTERN_STARTED,
      data,
    };
  }
  public static enableMicroServicesPatternSuccess(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_MICROSERVIVES_PATTERN_SUCCESS,
      data,
    };
  }
  public static enableMicroServicesPatternError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_MICROSERVIVES_PATTERN_ERROR,
      data,
    };
  }
  public static enableEtlPatternStarted(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_ETL_PATTERN_STARTED,
      data,
    };
  }
  public static enableEtlPatternSuccess(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_ETL_PATTERN_SUCCESS,
      data,
    };
  }
  public static enableEtlPatterError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENABLE_ETL_PATTERN_ERROR,
      data,
    };
  }

  public static configureCustomLandingZoneStarted(
    data: IConfigureLandingZonePayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_CUSTOM_LANDING_ZONE_STARTED,
      data,
    };
  }

  public static configureLandingZoneStarted(data: IConfigureLandingZonePayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_LANDING_ZONE_STARTED,
      data,
    };
  }
  public static configureLandingZoneSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_LANDING_ZONE_SUCCESS,
      data,
    };
  }
  public static configureLandingZoneLoading(data: IConfigureLZLoadingPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_LANDING_ZONE_LOADING,
      data,
    };
  }
  public static configureLandingZoneError(data: IConfigureLandingZoneError): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_LANDING_ZONE_ERROR,
      data,
    };
  }
  public static configureCustomLandingZoneError(data: {
    error: Error;
    index: number;
  }): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_CUSTOM_LANDING_ZONE_ERROR,
      data,
    };
  }
  public static configureMicroServicesPatternStarted(
    data: IConfigureWorkLoadsPattern,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_MICROSERVIVES_PATTERN_STARTED,
      data,
    };
  }
  public static configureMicroServicesLoading(
    data: ICheckMicroServicesPatternStatus,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_MICROSERVIVES_PATTERN_LOADING,
      data,
    };
  }
  public static configureMicroServicesPatternSuccess(
    data: ICheckMicroServicesPatternStatus,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_MICROSERVIVES_PATTERN_SUCCESS,
      data,
    };
  }
  public static configureMicroServicesPatternError(
    data: IConfigureMicroServiceError,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_MICROSERVIVES_PATTERN_ERROR,
      data,
    };
  }
  public static configureMicroServicesPatternFailed(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_MICROSERVIVES_PATTERN_FAILED,
      data,
    };
  }
  public static configureEtlPatternStarted(data: IConfigureWorkLoadsPattern): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_ETL_PATTERN_STARTED,
      data,
    };
  }
  public static configureEtlPatternSuccess(data: number): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_ETL_PATTERN_SUCCESS,
      data,
    };
  }
  public static configureEtlPatternError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_ETL_PATTERN_ERROR,
      data,
    };
  }
  public static deleteLandingZoneStarted(data: IDeleteLandingZonePayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DELETE_LANDING_ZONE_STARTED,
      data,
    };
  }

  public static deleteLandingZoneSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DELETE_LANDING_ZONE_SUCCESS,
      data,
    };
  }
  public static deleteLandingZoneError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DELETE_LANDING_ZONE_ERROR,
      data,
    };
  }
  public static destroyWorkLoadPatternStarted(
    data: IDeleteWorkLoadPatternPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DESTROY_WORKLOAD_PATTERN_STARTED,
      data,
    };
  }
  public static destroyWorkLoadPatternSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DESTROY_WORKLOAD_PATTERN_SUCCESS,
      data,
    };
  }
  public static destroyWorkLoadPatternError(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DESTROY_WORKLOAD_PATTERN_ERROR,
      data,
    };
  }

  public static getAllAvailableWorkLoadPatternStarted(
    data: IGetWorkloadQueryParams,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ALL_AVAILABLE_WORKLOAD_PATTERN_STARTED,
      data,
    };
  }
  public static getAllAvailableWorkLoadPatternSuccess(
    data: Array<IWorkloadPatternRespObj>,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ALL_AVAILABLE_WORKLOAD_PATTERN_SUCCESS,
      data,
    };
  }
  public static getAllAvailableWorkLoadPatternError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ALL_AVAILABLE_WORKLOAD_PATTERN_ERROR,
      data,
    };
  }

  public static getAllEnvironmentsStarted(data: IGetEnvironmentsQueryParams): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ALL_ENVIRONMENTS_STARTED,
      data,
    };
  }
  public static getAllEnvironmentsSuccess(data: Array<IAllEnvironmentsRespObj>): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ALL_ENVIRONMENTS_SUCCESS,
      data,
    };
  }
  public static getAllEnvironmentsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ALL_ENVIRONMENTS_ERROR,
      data,
    };
  }

  public static createEnvironmentStarted(data: ICreateEnvironmentPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CREATE_ENVIRONMENT_STARTED,
      data,
    };
  }
  public static createEnvironmentSuccess(data: IAllEnvironmentsRespObj): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CREATE_ENVIRONMENT_SUCCESS,
    };
  }
  public static createEnvironmentError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CREATE_ENVIRONMENT_ERROR,
      data,
    };
  }

  public static checkLandingZoneStatus(data: ICheckLandingZoneStatus): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CHECK_LANDING_ZONE_STATUS,
      data,
    };
  }
  public static getLandingZoneErrorStarted(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_LANDING_ZONE_ERRORS_STARTED,
      data,
    };
  }
  public static getLandingZoneErrorSuccess(data: ILandingZoneErrorResponse): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_LANDING_ZONE_ERRORS_SUCCESS,
      data,
    };
  }
  public static getLandingZoneErrorFailed(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_LANDING_ZONE_ERRORS_FAILED,
      data,
    };
  }
  public static configureLandingZoneFailed(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_LANDING_ERROR_SUCCESS,
      data,
    };
  }
  public static checkMicroServicesPatternStatus(
    data: ICheckMicroServicesPatternStatus,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CHECK_MICROSERVIVES_PATTERN_STATUS,
      data,
    };
  }
  public static setTotalEnvironmentsCount(data: ICountLandingZone): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_TOTAL_ENVIRONMENTS,
      data,
    };
  }
  public static setSelectedTab(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_SELECTED_TAB,
      data,
    };
  }
  public static createLandingZoneYamlStarted(data: ICreateYamlPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CREATE_LANDING_ZONE_YAML_START,
      data,
    };
  }
  public static createLandingZoneYamlSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CREATE_LANDING_ZONE_YAML_SUCCESS,
      data,
    };
  }

  public static createLandingZoneYamlError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CREATE_LANDING_ZONE_YAML_ERROR,
      data,
    };
  }
  public static getDeployedEnvironmentsDataStarted(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENVIRONMENTS_DEPLOYED_START,
      data,
    };
  }
  public static getDeployedEnvironmentsDataSuccess(
    data: IEnvironmentsDeployed[],
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENVIRONMENTS_DEPLOYED_SUCCESS,
      data,
    };
  }
  public static getDeployedEnvironmentsDataError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.ENVIRONMENTS_DEPLOYED_ERROR,
      data,
    };
  }
  public static getArchitectureListStarted(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ARCHITECTURE_LIST_STARTED,
    };
  }
  public static getArchitectureListSuccess(
    data: IArchitectureCatalogueResponse[],
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ARCHITECTURE_LIST_SUCCESS,
      data,
    };
  }

  public static landingZoneDeploymentStatusStart(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.LANDING_ZONES_DEPLOYMENT_STATUS_START,
      data,
    };
  }
  public static landingZoneDeploymentStatusSuccess(
    data: ILandingZoneDeploymentStatus[],
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.LANDING_ZONES_DEPLOYMENT_STATUS_SUCCESS,
      data,
    };
  }

  public static landingZoneDeploymentStatusError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.LANDING_ZONES_DEPLOYMENT_STATUS_ERROR,
      data,
    };
  }
  public static getArchitectureListError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_ARCHITECTURE_LIST_ERROR,
      data,
    };
  }
  public static onArchitectureViewCountStarted(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_ARCHTECTURE_VIEW_COUNT_STARTED,
      data,
    };
  }
  public static onArchitectureViewCountSuccess(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_ARCHTECTURE_VIEW_COUNT_SUCCESS,
    };
  }
  public static onArchitectureViewCountError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_ARCHTECTURE_VIEW_COUNT_ERROR,
      data,
    };
  }
  public static setArchitectureDiagramStarted(
    data: IArchitectureCataloguePayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_ARCHTECTURE_DIAGRAM_STARTED,
      data,
    };
  }
  public static setArchitectureDiagramSuccess(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_ARCHTECTURE_DIAGRAM_SUCCESS,
    };
  }

  public static setArchitectureDiagramError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_ARCHTECTURE_DIAGRAM_ERROR,
      data,
    };
  }
  public static getPipelinesAnalyticsStarted(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_PIPELINES_ANALYTICS_STARTED,
    };
  }
  public static getPipelinesAnalyticsSuccess(
    data: IPipelinesAnalyticsResponse[],
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_PIPELINES_ANALYTICS_SUCCESS,
      data,
    };
  }

  public static getPipelinesAnalyticsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_PIPELINES_ANALYTICS_ERROR,
      data,
    };
  }
  public static getPipelinesCummulativeAnalyticsStarted(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_PIPELINES_CUMMULATIVE_ANALYTICS_STARTED,
    };
  }
  public static getPipelinesCummulativeAnalyticsSuccess(
    data: IPipelinesCummulativeAnalyticsResponse[],
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_PIPELINES_CUMMULATIVE_ANALYTICS_SUCCESS,
      data,
    };
  }

  public static getPipelinesCummulativeAnalyticsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_PIPELINES_CUMMULATIVE_ANALYTICS_ERROR,
      data,
    };
  }
  public static getCloudLandingZoneKeysStarted(data: IGetKeysRequestBody): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_CLOUD_LANDING_ZONE_KEYS_STARTED,
      data,
    };
  }
  public static getCloudLandingZoneKeysSuccess(
    data: ICloudLandingZoneKeysResponse[],
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_CLOUD_LANDING_ZONE_KEYS_SUCCESS,
      data,
    };
  }

  public static getCloudLandingZoneKeysError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_CLOUD_LANDING_ZONE_KEYS_ERROR,
      data,
    };
  }
  public static setCloudLandingZoneKeysStarted(
    data: ICloudLandingZoneKeysPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_CLOUD_LANDING_ZONE_KEYS_STARTED,
      data,
    };
  }
  public static setCloudLandingZoneKeysSuccess(data: ILandingZoneState): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_CLOUD_LANDING_ZONE_KEYS_SUCCESS,
      data,
    };
  }

  public static setCloudLandingZoneKeysError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.SET_CLOUD_LANDING_ZONE_KEYS_ERROR,
      data,
    };
  }
  public static getYamlContentStarted(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_YAML_CONTENT_STARTED,
      data,
    };
  }
  public static getYamlContentSuccess(data: IYamlContent): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_YAML_CONTENT_SUCCESS,
      data,
    };
  }

  public static getYamlContentError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_YAML_CONTENT_ERROR,
      data,
    };
  }
  public static getDefaultTemplateYamlContentStarted(
    data: ICloudLandingZoneKeysPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_CONTENT_STARTED,
      data,
    };
  }
  public static getDefaultTemplateYamlContentForCloudStarted(
    data: ICloudLandingZoneKeysPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_CONTENT_FOR_CLOUD_STARTED,
      data,
    };
  }
  public static getDefaultTemplateYamlContentSuccess(data: any): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_CONTENT_SUCCESS,
      data,
    };
  }

  public static getDefaultTemplateYamlContentError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_CONTENT_ERROR,
      data,
    };
  }
  public static getIndustryYamlContentStarted(data: IIndustryYamlPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_INDUSTRY_YAML_CONTENT_STARTED,
      data,
    };
  }
  public static getIndustryYamlContentSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_INDUSTRY_YAML_CONTENT_SUCCESS,
      data,
    };
  }

  public static getIndustryYamlContentError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_INDUSTRY_YAML_CONTENT_ERROR,
      data,
    };
  }

  public static getDeploymentDetailStarted(data: {
    accountId: string;
    projectId: string;
  }): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOYMENT_DETAILS_STARTED,
      data,
    };
  }
  public static getDeploymentDetailsSuccess(data: IDeploymentsResponse[]): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOYMENT_DETAILS_SUCCESS,
      data,
    };
  }
  public static getDeploymentDetailsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOYMENT_DETAILS_ERROR,
      data,
    };
  }
  public static getWorkFlowLogsStarted(data: {
    landingZoneId: string;
    csp: string;
  }): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_WORKFLOW_LOGS_STARTED,
      data,
    };
  }
  public static getWorkFlowLogsSuccess(data: IWorkFLowLogsResponse): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_WORKFLOW_LOGS_SUCCESS,
      data,
    };
  }
  public static getWorkFlowLogsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_WORKFLOW_LOGS_ERROR,
      data,
    };
  }
  public static cloudLandingZoneDeployStatusStarted(data: string): BuildDeployAction {
    //Takes ID as argument
    return {
      type: BuildDeployActionTypes.CLOUD_LANDING_ZONE_DEPLOY_STATUS_STARTED,
      data,
    };
  }
  public static cloudLandingZoneDeployStatusSuccess(
    data: ILandingZoneDeploymentResponse,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CLOUD_LANDING_ZONE_DEPLOY_STATUS_SUCCESS,
      data,
    };
  }

  public static cloudLandingZoneDeployStatusError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CLOUD_LANDING_ZONE_DEPLOY_STATUS_ERROR,
      data,
    };
  }
  public static configureDeployCloudStarted(data: IConfigureDeployCloudPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_DEPLOY_CLOUD_STARTED,
      data,
    };
  }
  public static configureDeployCloudSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_DEPLOY_CLOUD_SUCCESS,
      data,
    };
  }
  public static configureDeployCloudError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_DEPLOY_CLOUD_ERROR,
      data,
    };
  }

  public static configureDeployCloudThroughConsoleStarted(
    data: IConfigureDeployCloudThroughConsolePayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_STARTED,
      data,
    };
  }
  public static configureDeployCloudThroughConsoleSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_SUCCESS,
      data,
    };
  }
  public static configureDeployCloudThroughConsoleError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONFIGURE_DEPLOY_CLOUD_THROUGH_CONSOLE_STARTED,
      data,
    };
  }

  public static getDeploymentAuditStarted(data: IDeploymentLogsPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOYMENT_AUDIT_STARTED,
      data,
    };
  }
  public static getDeploymentAuditSuccess(data: IDeploymentLogsResponse[]): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOYMENT_AUDIT_SUCCESS,
      data,
    };
  }
  public static getDeploymentAuditError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOYMENT_AUDIT_ERROR,
      data,
    };
  }

  public static getDeployInputs(data: IDeployValueState): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEPLOY_INPUTS,
      data,
    };
  }

  public static cloudLandingZoneDeployDetailedLogsStarted(
    data: IUpdateLandingZoneDeployDetails,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_STARTED,
      data,
    };
  }
  public static cloudLandingZoneDeployDetailedLogsSuccess(
    data: IDeployActivityHistory,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_SUCCESS,
      data,
    };
  }
  public static cloudLandingZoneDeployDetailedLogsError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CLOUD_LANDING_ZONE_DEPLOY_DETAILED_LOGS_ERROR,
      data,
    };
  }
  public static getMultiCloudYamlContentStarted(data: IFormInterface): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_MULTICLOUD_YAML_CONTENT_STARTED,
      data,
    };
  }
  public static getMultiCloudYamlContentSuccess(data: any): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_MULTICLOUD_YAML_CONTENT_SUCCESS,
      data,
    };
  }
  public static getMultiCloudYamlContentError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_MULTICLOUD_YAML_CONTENT_ERROR,
      data,
    };
  }

  public static getPreviewYamlArchitectureStarted(
    data: IConfigureLandingZonePayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_STARTED,
      data,
    };
  }
  public static getPreviewYamlArchitectureSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_SUCCESS,
      data,
    };
  }
  public static getPreviewYamlArchitectureError(
    data: IConfigureLandingZoneError,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_DEFAULT_TEMPLATE_YAML_ARCH_DIAGRAM_ERROR,
      data,
    };
  }

  public static deployLandingZoneStarted(data: IConfigureLandingZonePayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DEPLOY_LANDING_ZONE_STARTED,
      data,
    };
  }
  public static deployLandingZoneSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DEPLOY_LANDING_ZONE_SUCCESS,
      data,
    };
  }
  public static deployLandingZoneLoading(data: IConfigureLZLoadingPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DEPLOY_LANDING_ZONE_LOADING,
      data,
    };
  }
  public static deployLandingZoneError(data: IConfigureLandingZoneError): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.DEPLOY_LANDING_ZONE_ERROR,
      data,
    };
  }

  public static validateYamlStarted(data: IUploadPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_YAML_STARTED,
      data,
    };
  }
  public static validateYamlForCloudStarted(data: IUploadPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_YAML_FOR_CLOUD_STARTED,
      data,
    };
  }

  public static validateYamlSuccess(data: IValidateYamlPayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_YAML_SUCCESS,
      data,
    };
  }
  public static validateLandingZoneStarted(data: IValidateLandingZonePayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_LANDING_ZONE_STARTED,
      data,
    };
  }
  public static validateLandingZoneSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_LANDING_ZONE_SUCCESS,
      data,
    };
  }
  public static validateLandingZoneError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_LANDING_ZONE_ERROR,
      data,
    };
  }
  public static validateYamlError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_YAML_ERROR,
      data,
    };
  }
  public static validateCustomTemplateError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_ERROR,
      data,
    };
  }

  public static validateYamlClear(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_YAML_CLEAR,
    };
  }

  public static fetchIndustryPoliciesStarted(data?: IIndustryPolicyRequest): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICIES_STARTED,
      data,
    };
  }
  public static fetchIndustryPoliciesForCloudStarted(
    data?: IIndustryPolicyRequest,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICIES_FOR_CLOUD_STARTED,
      data,
    };
  }
  public static fetchIndustryPoliciesSuccess(data: Array<IIndustryPolicy>): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICIES_SUCCESS,
      data,
    };
  }
  public static fetchIndustryPoliciesError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICIES_ERROR,
      data,
    };
  }

  public static fetchIndustryCompliancesStarted(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_COMPLIANCES_STARTED,
    };
  }
  public static fetchIndustryCompliancesSuccess(
    data: Array<IIndustryCompliance>,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_COMPLIANCES_SUCCESS,
      data,
    };
  }
  public static fetchIndustryCompliancesError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.FETCH_INDUSTRY_COMPLIANCES_ERROR,
      data,
    };
  }
  public static downloadArchitectureDiagramStart = (data: IDownloadArchitectureDiagramPayload) => ({
    type: BuildDeployActionTypes.DOWNLOAD_ARCHITECTURE_DIAGRAM_START,
    data,
  });
  public static downloadArchitectureDiagramSuccess = (data: string) => ({
    type: BuildDeployActionTypes.DOWNLOAD_ARCHITECTURE_DIAGRAM_SUCCESS,
    data,
  });
  public static downloadArchitectureDiagramError = (data: Error) => ({
    type: BuildDeployActionTypes.DOWNLOAD_ARCHITECTURE_DIAGRAM_ERROR,
    data,
  });
  public static downloadArchitectureDiagramClear = () => ({
    type: BuildDeployActionTypes.DOWNLOAD_ARCHITECTURE_DIAGRAM_CLEAR,
  });

  public static getCategoryAndTechDomainStart = () => ({
    type: BuildDeployActionTypes.FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_START,
  });
  public static getCategoryAndTechDomainSuccess = (data: IFetchCategoryAndTechDomainResponse) => ({
    type: BuildDeployActionTypes.FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_SUCCESS,
    data,
  });
  public static getCategoryAndTechDomainError = (data: Error) => ({
    type: BuildDeployActionTypes.FETCH_CATEGORY_AND_TECHDOMAIN_OPTIONS_ERROR,
    data,
  });

  public static uploadArchitectureStart = (data: IUploadArchitecturePayload) => ({
    type: BuildDeployActionTypes.UPLOAD_ARCHITECTURE_START,
    data,
  });
  public static uploadArchitectureSuccess = () => ({
    type: BuildDeployActionTypes.UPLOAD_ARCHITECTURE_SUCCESS,
  });
  public static uploadArchitectureError = (data: Error) => ({
    type: BuildDeployActionTypes.UPLOAD_ARCHITECTURE_ERROR,
    data,
  });

  public static getIndustryPolicyYamlStart = (data: Array<string>) => ({
    type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICY_YAML_START,
    data,
  });
  public static getIndustryPolicyYamlSuccess = (data: any) => ({
    type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICY_YAML_SUCCESS,
    data,
  });
  public static getIndustryPolicyYamlError = (data: Error) => ({
    type: BuildDeployActionTypes.FETCH_INDUSTRY_POLICY_YAML_ERROR,
    data,
  });

  public static getTerraformCodeStart = (data: IUploadPayload) => ({
    type: BuildDeployActionTypes.FETCH_TERRAFORM_CODE_START,
    data,
  });
  public static getTerraformCodeForCloudStart = (data: IUploadPayload) => ({
    type: BuildDeployActionTypes.FETCH_TERRAFORM_CODE_FOR_CLOUD_START,
    data,
  });
  public static getTerraformCodeSuccess = (data: string) => ({
    type: BuildDeployActionTypes.FETCH_TERRAFORM_CODE_SUCCESS,
    data,
  });
  public static getTerraformCodeError = (data: Error) => ({
    type: BuildDeployActionTypes.FETCH_TERRAFORM_CODE_ERROR,
    data,
  });

  public static getGenAiCreateServicesStarted(data: IGetKeysRequestBody): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_SERVICES_STARTED,
      data,
    };
  }
  public static getGenAiCreateServicesSuccess(
    data: Record<string, Array<string>>,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_SERVICES_SUCCESS,
      data,
    };
  }
  public static getGenAiCreateServicesError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_SERVICES_ERROR,
      data,
    };
  }

  public static getGenAiCreateYamlContentStarted(data: IGenAiCreatePayload): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_YAML_CONTENT_STARTED,
      data,
    };
  }
  public static getGenAiCreateYamlContentSuccess(data: IGenAiCreateResponse): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_YAML_CONTENT_SUCCESS,
      data,
    };
  }
  public static getGenAiCreateYamlContentError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_YAML_CONTENT_ERROR,
      data,
    };
  }

  public static getGenAiCreatePollSuccess(data: any): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_POLLING_SUCCESS,
      data,
    };
  }
  public static getGenAiCreatePollError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_POLLING_ERROR,
      data,
    };
  }

  public static getGenAiCreateDownloadStarted(
    data: IGenAiCreateDownloadPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_DOWNLOAD_STARTED,
      data,
    };
  }
  public static getGenAiCreateDownloadSuccess(data: string): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_DOWNLOAD_SUCCESS,
      data,
    };
  }
  public static getGenAiCreateDownloadError(data: Error): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_GEN_AI_CREATE_DOWNLOAD_ERROR,
      data,
    };
  }

  public static validateCustomTemplateDelpoymentZipFileStarted(
    data: IValidateCustomConfigurationPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.VALIDATE_CUSTOM_TEMPLATE_ZIP_FILE_STARTED,
      data,
    };
  }

  public static uploadCustomTemplateDelpoymentZipFileStarted(
    data: IUploadCustomCloudConfigurationFilePayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_STARTED,
      data,
    };
  }
  public static uploadCustomTemplateDelpoymentZipFileSuccess(
    data: IUploadCustomCloudConfigurationFileResponse,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_SUCCESS,
      data,
    };
  }
  public static uploadCustomTemplateDelpoymentZipFileError(data: any): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.UPLOAD_CUSTOM_TEMPLATE_ZIP_FILE_ERROR,
      data,
    };
  }

  public static handleHardReload = (): BuildDeployAction => ({
    type: BuildDeployActionTypes.BUILD_DEPLOY_HARD_RELOAD,
  });

  public static getEnvironmentBuildCloudConfigurationVariablesError(
    data: Error,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_CLOUD_BUILD_CONFIG_VARIABLES_ERROR,
      data,
    };
  }

  public static getEnvironmentBuildCloudConfigurationVariablesSuccess(
    data: Array<ICloudBuildConfigVariable>,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_CLOUD_BUILD_CONFIG_VARIABLES_SUCCESS,
      data,
    };
  }

  public static getEnvironmentBuildCloudConfigurationVariablesStarted(
    data: ICloudBuildTfVarsPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GET_CLOUD_BUILD_CONFIG_VARIABLES_STARTED,
      data,
    };
  }

  public static generateArchitectureDiagramsStarted(
    data: IGenerateArchitectureDiagramsPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GENERATE_ARCHITECTURE_DIAGRAMS_STARTED,
      data,
    };
  }
  public static generateArchitectureDiagramsError(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.GENERATE_ARCHITECTURE_DIAGRAMS_ERROR,
    };
  }
  public static generateArchitectureDiagramsSuccess(
    data: IGenerateArchitectureDiagramsResponse,
    diagramType: DiagramType,
  ): BuildDeployAction {
    console.log('generateArchitectureDiagramsSuccess', data);
    return {
      type: BuildDeployActionTypes.GENERATE_ARCHITECTURE_DIAGRAMS_SUCCESS,
      data: {
        ...data,
        diagramType: diagramType,
      } as IGeneratedArchitectureDiagramHistoryStackItem,
    };
  }
  public static reviseGeneratedArchitectureDiagramStarted(
    data: IReviseArchitectureDiagramsPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_STARTED,
      data,
    };
  }
  public static reviseGeneratedArchitectureDiagramError(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_ERROR,
    };
  }
  public static generateArchitectureDiagramsRevisionSuccess(
    data: IGenerateArchitectureDiagramsResponse,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.REVISE_GENERATED_ARCHITECTURE_DIAGRAMS_SUCCESS,
      data,
    };
  }
  public static generateArchitectureDiagramsConversionStarted(
    data: IConvertArchitectureDiagramsPayload,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_STARTED,
      data,
    };
  }
  public static generateArchitectureDiagramsConversionError(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_ERROR,
    };
  }
  public static generateArchitectureDiagramsConversionSuccess(
    data: IConvertArchitectureDiagramsResponse,
    diagramType: DiagramType,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.CONVERT_GENERATED_ARCHITECTURE_DIAGRAMS_SUCCESS,
      data: {
        ...data,
        diagramType: diagramType,
      } as IConvertArchitectureDiagramsResponseWithType,
    };
  }

  public static uploadGeneratedArchitectureDiagramStarted(
    data: IUploadArchitectureDiagramsPayloadWithFile,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_STARTED,
      data,
    };
  }

  public static uploadGeneratedArchitectureDiagramSuccess(
    data: IUploadArchitectureDiagramsResponse,
  ): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_SUCCESS,
      data,
    };
  }

  public static uploadGeneratedArchitectureDiagramError(): BuildDeployAction {
    return {
      type: BuildDeployActionTypes.UPLOAD_GENERATED_ARCHITECTURE_DIAGRAM_ERROR,
    };
  }

  public static undoDiagram = () => ({
    type: BuildDeployActionTypes.UNDO_DIAGRAM,
  });

  public static redoDiagram = () => ({
    type: BuildDeployActionTypes.REDO_DIAGRAM,
  });

  public static clearDiagramsHistory = () => ({
    type: BuildDeployActionTypes.CLEAR_DIAGRAM_HISTORY_AND_CURRENT,
  });
}
